import { render } from "./ResetPasswordDialog.vue?vue&type=template&id=5a1ecdb2"
import script from "./ResetPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ResetPasswordDialog.vue?vue&type=script&lang=js"

import "./ResetPasswordDialog.vue?vue&type=style&index=0&id=5a1ecdb2&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__